import React from 'react';
import { Button, Card, Col, Container, Form, Image, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt, faMobileAlt, faPaperPlane, faMapMarked } from '@fortawesome/free-solid-svg-icons';
import emailjs from 'emailjs-com';
import './Contact.css';
import Swal from 'sweetalert2';

const Contact = () => {
    // Font Awesome Icon
    const cardIcon1 = <FontAwesomeIcon icon={faPhoneAlt} />
    const numberIcon = <FontAwesomeIcon icon={faMobileAlt} />
    const cardIcon2 = <FontAwesomeIcon icon={faPaperPlane} />
    const cardIcon3 = <FontAwesomeIcon icon={faMapMarked} />

    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_9gahmy9', 'template_sl3itus', e.target, 'user_ebJgh3yMKpD2oipIu2OAH')
        .then((result) => {
            Swal.fire("Email Send SuccessFully!",
                            "Success"
                        )
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset();
    };

    return (
        
        <>
        <section className="contact-header text-center text-light">
            <Container>
                <Row className="py-4">
                    <div className="col-md-2"></div>
                    <div className="col-md-8">
                        <span style={{color: 'tomato'}}>CONTACT ME TODAY</span>
                        <h1 className="my-3">Build Beautiful Websites today!</h1>
                        <p>I am a passionate web developer and always trying to learn different technologies related to web development. Being a friendly person, I love to take on challenges and always try to fulfill my responsibilities.</p>
                    </div>
                    <div className="col-md-2"></div>
                </Row>
            </Container>
            {/* featured Part */}
            <section className="featured py-4">
            <Container className="mx-auto">
                <Row className="mx-auto">
                <div className="col-md-4 text-center mb-3">
                        <Card className="featured-card py-3">
                        <Card.Body className="featured-card-body">
                            <Card.Title> <p className="card-icon">{cardIcon1}</p> </Card.Title>
                            <Card.Text className="card-text">
                                <h3>Call Me today</h3>
                                <span>{numberIcon}  +880 1833923107</span> 
                            </Card.Text>
                        </Card.Body>
                        </Card>
                    </div>
                    <div className="col-md-4 text-center mb-3">
                        <Card className="featured-card py-3">
                        <Card.Body className="featured-card-body">
                            <Card.Title> <p className="card-icon">{cardIcon2}</p> </Card.Title>
                            <Card.Text className="card-text">
                                <h3>Send Me Email</h3>
                                <span>romansheikh170@gmail.com</span> 
                            </Card.Text>
                        </Card.Body>
                        </Card>
                    </div>
                    <div className="col-md-4 text-center mb-3">
                        <Card className="featured-card py-3">
                        <Card.Body className="featured-card-body">
                            <Card.Title> <p className="card-icon">{cardIcon3}</p> </Card.Title>
                            <Card.Text className="card-text">
                                <h3>Location</h3>
                                <p>Digpait, Jamalpur <br />
                                Mymensingh, Bangladesh</p>
                            </Card.Text>
                        </Card.Body>
                        </Card>
                    </div>
                </Row>
            </Container>
        </section>
        </section>
        <section className="contact-section py-5">
        <div>
            <Container>
                <Row className="text-center">
                    <div className="col-md-2"></div>
                    <div className="col-md-8 my-3 text-light">
                        <h1>Get In Touch!</h1>
                        <p>We've answered our most common queries in the FAQs. · If you have a query regarding a payment, or wish to change your billing date, you can call usWe've answered our.</p>
                    </div>
                    <div className="col-md-2"></div>
                </Row>
            </Container>
        </div>
        <div>
            <Container>
                <Row className="text-center my-5">
                <div className="col-md-6 my-5">
                <Image src="https://i.ibb.co/6FSWYnS/b78b7986b0964ce42f8fc93b6fcbea6d.png" fluid />
                </div>
                {/* Contact Form Part */}
                <div className="col-md-6 my-5">
                    <Form className="contact my-5" onSubmit={sendEmail}>
                    <Form.Text className="text-center">
                            <h1 className="py-3 text-light">Contact Me</h1>
                        </Form.Text>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formGridName">
                            <Form.Control name="user_name" className="contact-input" type="text" placeholder="Enter Name" />
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridEmail">
                            <Form.Control name="user_email" className="contact-input" type="email" placeholder="Enter Email" />
                            </Form.Group>
                        </Row>

                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                 <Form.Control name="message" className="contact-input" as="textarea" rows={3} placeholder="Massage"/>
                            </Form.Group>

                        <Button style={{backgroundImage: 'linear-gradient(90deg,#f61b10,#ef0963)', border: 'none'}} className="w-100" type="submit">
                            Submit
                        </Button>
                    </Form>
                </div>
                </Row>
                
            </Container>
            
        </div>
        </section>
        </>
    );
};

export default Contact;